import type { FunctionComponent, ReactNode } from 'react';

import './style.scss';

type PropsT = {
  children: ReactNode;
};

const EquipmentItem: FunctionComponent<PropsT> = ({ children }) => (
  <div styleName="container">
    <span styleName="check" />
    <span styleName="label">{children}</span>
  </div>
);

export default EquipmentItem;
